import type { BeckyExperiments } from '@wix/thunderbolt-commons'
import type { DataMapName } from '@wix/thunderbolt-becky-types'
import { componentCssFactory } from './componentCssCompNode'
import { componentPatternsFactory } from './commonCssData/patternsCompNode'
import {
	componentVisibilityTransformationsFactory,
	containerVisibilityTransformationsFactory,
} from './commonCssData/visibilityTransformationsCompNode'
import { multi, withDependencies } from '@wix/thunderbolt-ioc'
import { CssFeatureSymbol } from '../ioc/catharsis-ioc'
import { appConstant } from '@wix/thunderbolt-catharsis-ioc'
import type { CompNodesProvider } from '@wix/thunderbolt-catharsis-ioc'

export const defaultDataMaps: Array<DataMapName> = ['patterns', 'variants_data', 'transformations_data']

export type IsExperimentOpen = (experimentName: keyof BeckyExperiments) => boolean

export const CssCompNodesProvider = withDependencies(
	[multi(CssFeatureSymbol), appConstant('isExperimentOpen')] as const,
	(features, isExperimentOpen): CompNodesProvider => {
		const activeCssFeatures = features.filter(
			({ experimentName }) => experimentName === 'OPEN_TO_ALL' || isExperimentOpen(experimentName)
		)

		const componentNodes = activeCssFeatures.reduce(
			(acc, { renderableNodes, intermediateNodes }) => ({ ...acc, ...renderableNodes, ...intermediateNodes }),
			{
				repeaterPatterns: componentPatternsFactory(),
				componentCss: componentCssFactory(activeCssFeatures),
				componentVisibilityTransformations: componentVisibilityTransformationsFactory(),
				visibilityTransformations: containerVisibilityTransformationsFactory(),
			}
		)

		const usedDataMaps = activeCssFeatures.flatMap(({ dataMaps }) => dataMaps).concat(defaultDataMaps)
		return {
			getCompNodes: () => componentNodes,
			getUsedDataMaps: () => usedDataMaps,
		}
	}
)
